import {Service, service, inject} from "./di";
import {AuthenticationService} from "./AuthenticationService";
import {AuthStatus} from "./definitions/IAuthenticationService";
import {LinkService} from "./LinkService";
import {EventService} from "./EventService";



@service("DataFormSevice")
export class DataFormService extends Service {
	@inject auth: AuthenticationService;
	@inject eventService: EventService;

	redirectToForm ()  {
		const linkService = LinkService.getInstance();
		linkService.execute("/data", window);
	}

	handleFormClicked = () => {
		const linkService = LinkService.getInstance();
		if (Number(this.auth.status) === Number(AuthStatus.LOGGED_OUT)) {
			linkService.execute("/signin#data", window);
		} else {
			this.redirectToForm();
		}
	}

	unsubscribeFromRedirect = () => {
		window.removeEventListener("redirect-to-form", this.redirectToForm);
	}
}
